'use es6';

import { FETCH_EVENT_DETAILS_SUCCEEDED } from '../actions/ActionTypes';
var initialState = null;
export default function eventDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_EVENT_DETAILS_SUCCEEDED:
      return action.payload;

    default:
      return state;
  }
}